import { Linkedin } from "lucide-react";
import { FadeUp, ClipReveal } from "./Reveal";
import { FOUNDER, AWARDS, IMAGES } from "../../lib/site";

export default function Founder() {
  return (
    <section id="founder" className="relative py-24 lg:py-32 bg-[#050B14] border-y border-white/10" data-testid="founder-section">
      <div className="pointer-events-none absolute top-1/2 right-0 h-[400px] w-[400px] rounded-full bg-[#00D166]/10 blur-[120px]" />
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-5">
          <ClipReveal className="relative aspect-[3/4] overflow-hidden border border-white/10">
            <img src={IMAGES.founder} alt={FOUNDER.name} className="h-full w-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-transparent to-transparent" />
          </ClipReveal>
        </div>

        <div className="lg:col-span-7">
          <FadeUp>
            <span className="font-body text-xs tracking-[0.35em] text-[#00D166]">THE FOUNDER</span>
            <blockquote className="mt-6 font-serifed italic text-2xl md:text-4xl leading-tight text-white">
              “{FOUNDER.quote}”
            </blockquote>
            <div className="mt-8 flex items-center gap-4">
              <div>
                <h3 className="font-display text-2xl font-bold text-white">{FOUNDER.name}</h3>
                <p className="font-body text-sm text-[#00D166]">{FOUNDER.role}</p>
              </div>
              <a
                href={FOUNDER.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="founder-linkedin"
                className="ml-2 grid h-10 w-10 place-items-center border border-white/20 text-white hover:bg-[#00D166] hover:text-[#030712] hover:border-[#00D166] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
            <p className="mt-6 font-body text-white/60 leading-relaxed max-w-xl">{FOUNDER.bio}</p>

            <div className="mt-8 flex flex-wrap gap-3">
              {FOUNDER.creds.map((c) => (
                <span key={c} className="font-body text-xs text-white/80 border border-white/15 px-3 py-2">{c}</span>
              ))}
            </div>

            <div className="mt-10 border-t border-white/10 pt-8">
              <p className="font-body text-xs tracking-[0.3em] text-white/40 mb-4">RECOGNITION</p>
              <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
                {AWARDS.map((a) => (
                  <li key={a} className="flex items-start gap-2 font-body text-sm text-white/70">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-[#00D166]" /> {a}
                  </li>
                ))}
              </ul>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
